import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ServicioService } from '../servicio.service';

@Component({
  selector: 'app-servicio-create',
  templateUrl: './servicio-create.component.html',
  styleUrls: ['./servicio-create.component.scss']
})
export class ServicioCreateComponent implements OnInit {

  form: FormGroup = new FormGroup({});
  
  constructor(
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: ServicioService,
    public formatter: FormatterService
  ) {}
  
  ngOnInit() {
    this.form = this.formBuilder.group({
      nombre: [null, [Validators.required]],
      precio_venta: [null],
      descripcion: [null],
    });
  }
  
  guardar(){
    if(this.form.valid){
      this.loading.show();
      this.service.create(this.form.value).subscribe({ next: (res) => {
        this.loading.hide();
        this.activeModal.close(res.model);
      }, error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar el servicio.", "danger");
      }})
    } else {
      this.form.markAllAsTouched();
    }
  }

}
